var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { Progress } from 'semantic-ui-react';
var ActionLoading = /** @class */ (function (_super) {
    __extends(ActionLoading, _super);
    function ActionLoading(props) {
        var _this = _super.call(this, props) || this;
        var _a = props.data, loadingStep = _a.loadingStep, timerSteps = _a.timerSteps, defaultText = _a.defaultText;
        _this.state = {
            now: 10,
            text: defaultText,
        };
        _this.loadingStep = loadingStep;
        _this.timerSteps = timerSteps;
        _this.updateProgress = _this.updateProgress.bind(_this);
        return _this;
    }
    ActionLoading.prototype.componentDidMount = function () {
        this.inititateProgress(this.timerSteps[0], 0);
    };
    ActionLoading.prototype.inititateProgress = function (timer, index) {
        var _this = this;
        setTimeout(function () { return _this.updateProgress(index); }, timer);
    };
    ActionLoading.prototype.updateProgress = function (index) {
        var _this = this;
        if (index === 5)
            return;
        var _a = this.props.data, loadingStepText = _a.loadingStepText, defaultText = _a.defaultText;
        this.setState({
            now: this.loadingStep[index],
            text: loadingStepText ? loadingStepText[index] : defaultText,
        });
        setTimeout(function () { return _this.updateProgress(index + 1); }, this.timerSteps[index + 1]);
    };
    ActionLoading.prototype.render = function () {
        var _a = this.state, now = _a.now, text = _a.text;
        var _b = this.props, data = _b.data, progressProps = __rest(_b, ["data"]);
        return (React.createElement(Progress, __assign({ percent: now }, progressProps, { active: true }),
            React.createElement("div", { style: { fontSize: 12, textAlign: 'left' } }, text)));
    };
    return ActionLoading;
}(Component));
export default ActionLoading;
